import Button from '@atlaskit/button/custom-theme-button';
import { token } from '@atlaskit/tokens';
import styled from '@emotion/styled';

// TODO-typescript-upgrade
export const FeedbackButton = styled(Button as any)`
  margin-top: ${token('space.200', '16px')};
  display: block;
`;
